export default {"src":"/_next/static/media/hands.a70e9491.svg","height":37,"width":47,"blurWidth":0,"blurHeight":0};